import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';
import { useLanguage } from '../../contexts/LanguageContext';
import './MyCourses.css';

const MyCourses = () => {
  const { t, language } = useLanguage();
  const [enrollments, setEnrollments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEnrollments = async () => {
      try {
        const response = await apiService.getMyEnrollments();
        if (response.success) {
          setEnrollments(response.data);
        } else {
          throw new Error(response.message || t('dashboard.courses.errors.fetchFailed'));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEnrollments();
  }, []);

  const numberLocale = language === 'hi' ? 'hi-IN' : language === 'or' ? 'or-IN' : 'en-IN';

  if (isLoading) return <div className="loading-spinner">{t('dashboard.courses.loading')}</div>;

  if (error) {
    return <div className="error-message">{t('dashboard.common.errorPrefix')}: {error}</div>;
  }

  return (
    <div className="my-courses-container">
      <h2>{t('dashboard.courses.title')}</h2>
      {enrollments.length === 0 ? (
        <div className="no-courses">
          <p>{t('dashboard.courses.emptyMessage')}</p>
          <Link to="/bhakti-yoga" className="btn btn-primary">{t('dashboard.courses.exploreCourses')}</Link>
        </div>
      ) : (
        <div className="enrolled-courses-grid">
          {enrollments.map((enrollment) => (
            <div key={enrollment._id} className="enrolled-course-card">
              <img src={enrollment.course?.thumbnail} alt={enrollment.course?.title} className="course-thumbnail" />
              <div className="course-info">
                <h3>{enrollment.course?.title || t('dashboard.courses.courseTitleMissing')}</h3>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${enrollment.completionPercentage}%` }}
                  ></div>
                </div>
                <p className="progress-text">{t('dashboard.courses.progressComplete', { percent: Math.round(enrollment.completionPercentage).toLocaleString(numberLocale) })}</p>
                <Link to={`/courses/player/${enrollment.course?._id}`} className="btn-resume">
                  {enrollment.completionPercentage > 0 ? t('dashboard.courses.resumeCourse') : t('dashboard.courses.startCourse')}
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyCourses;
